import BaseAPI from './base/base-api';

class NotificationBannerAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'notifications';

	/**
	 * Lấy thông báo hệ thống đang active (public endpoint, cho phép anonymous)
	 * @returns {Promise} ServiceResult<NotificationSystemDto>
	 */
	async getActive() {
		const me = this;
		return await me.getAsync({ url: me.getAPIUrl('active') });
	}
}

export default new NotificationBannerAPI();
